import AmountScreen from 'features/rdc/screens/Amount/AmountScreen';
import React from 'react';

export default function AmountScreenPage() {
  return <AmountScreen />;
}
